const SUPERMARKET_LOGOS = [
  {
    keys: ['continente'],
    src: '/continente_full.png',
    label: 'Continente',
    homepage: 'https://www.continente.pt',
  },
  {
    keys: ['auchan'],
    src: '/auchan_full.png',
    label: 'Auchan',
    homepage: 'https://www.auchan.pt',
  },
  {
    keys: ['pingo doce', 'pingodoce'],
    src: '/pingo_doce_full.png',
    label: 'Pingo Doce',
    homepage: 'https://www.pingodoce.pt',
  },
  {
    keys: ['intermarché', 'intermarche'],
    src: '/intermarche_full.png',
    label: 'Intermarche',
    homepage: 'https://www.intermarche.pt',
  },
];

const normalize = (value) =>
  (value || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

export const getSupermarketLogo = (name) => {
  const normalizedName = normalize(name);
  const match = SUPERMARKET_LOGOS.find((entry) =>
    entry.keys.some((key) => normalizedName.includes(normalize(key)))
  );

  if (!match) {
    return null;
  }

  return {
    src: match.src,
    label: match.label,
    homepage: match.homepage,
  };
};
